export const parseGreetingsObjectString = (
  input: string
): Array<{ label: string; text: string }> => {
  if (!input || !input.trim()) return [];

  try {
    const objectStrings = input.split(/};\s*/).filter(str => str.trim());
    const result: Array<{ label: string; text: string }> = [];

    for (let objStr of objectStrings) {
      objStr = objStr.trim();
      if (!objStr.endsWith('}')) {
        objStr += '}';
      }

      const labelMatch = objStr.match(/label\s*:\s*["']([^"']*)["']/);
      const textMatch = objStr.match(/text\s*:\s*["']([^"']*)["']/);

      result.push({
        label: labelMatch ? labelMatch[1] : '',
        text: textMatch ? textMatch[1] : '',
      });
    }

    return result;
  } catch (error) {
    console.warn('Failed to parse greetings objects:', error);
    return [];
  }
};

export const formatGreetingsObjectsToString = (
  objects: Array<{ label: string; text: string }>
): string => {
  if (!objects || objects.length === 0) return '';

  return objects
    .map(obj => `{label: "${obj.label}", text: "${obj.text}"}`)
    .join('; ');
};
